<template>
    
    <div class="w-full flex flex-col mb-2 border-b" :class="{'h-32': !open, 'h-96': open}" style="transition: all .3s;">

        <div class="h-32 w-full px-4" @click="open=!open">

            <div class="h-20 w-full flex flex-row justify-between items-center ">

                <div class="h-full w-1/2 flex flex-col justify-center items-start">
                
                    <span class="font-semibold text-md">{{data.customer_name || 'Sin Nombre'}}</span>
                    <span class="text-sm text-gray-600">{{data.city || 'Sin dirección'}}</span>

                </div>

                <div class="h-full w-1/2 flex flex-row justify-end items-center">
                
                    <span class="font-semibold text-lg text-blue-500">{{data.total}}€</span>

                </div>

            </div>

            <div class="h-8 bg-white flex flex-row justify-start items-center">

                <div class="px-2 bg-red-200 h-auto rounded-full flex flex-row justify-center items-center">
                    <span class="text-sm text-red-700">{{data.store}}</span>
                </div>

                <span class="text-sm ml-auto text-green-500">{{data.quantity}}</span>
                <i class="mdi mdi-package-variant-closed text-green-500"></i>

                <div class="px-2 bg-green-700 h-auto rounded-full ml-2 flex flex-row justify-center items-center">
                    <span class="text-sm text-white mr-1">{{data.customer_sales}}</span>
                    <i class="mdi mdi-shopping-outline text-sm text-white"></i>
                </div>

            </div>

        </div>

        <div class="flex-1 overflow-hidden">

            <div class="h-full overflow-y-auto">

                <producInOrder v-for="(el,index) in data.products" :data="el" :key="index"></producInOrder>

            </div>

        </div>

    </div>

</template>

<script>
import producInOrder from './productInOrder';

export default {
    props:['data'],
    components:{
        producInOrder
    },
    data(){
        return{
            open: false
        }
    }
}
</script>